export default __webpack_public_path__ + "2d9eeba7b0608089ee18212321eed3a0.png";